<template>
    <div id="agent-authorizations-page">
        <loader v-if="is('loading')" :addBackground="true"></loader>

        <div class="container-fluid" v-if="is('ready')">
            <div class="box padding-large page-content">
                <div class="title-container">
                    <div>
                        <h1>{{ t('agentAuthorizations-manage_title') }}</h1>
                        <p class="text-sm text-muted mb-0">
                            {{ t('agentAuthorizations-manage_description') }}
                        </p>
                    </div>
                </div>

                <div class="box box-secondary mt-4" v-if="authorizations.length > 0">
                    <div class="table-responsive">
                        <table class="table table-secondary">
                            <thead>
                                <tr>
                                    <th>{{ t('agentAuthorizations-manage_address') }}</th>
                                    <th>{{ t('agentAuthorizations-manage_authorizer') }}</th>
                                    <th>{{ t('agentAuthorizations-manage_last_used') }}</th>
                                    <th class="text-right">{{ t('agentAuthorizations-manage_actions') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in authorizations" :key="item.id">
                                    <td>{{ formatAddress(item) }}</td>
                                    <td>{{ item.authorizer_name || item.authorizer_email }}</td>
                                    <td>{{ formatDate(item.last_used_at || item.confirmed_at) }}</td>
                                    <td class="text-right">
                                        <button
                                            class="btn btn-outline btn-small"
                                            type="button"
                                            @click="revoke(item)"
                                            :disabled="revokingId === item.id"
                                        >
                                            <span
                                                class="fa fa-spin fa-spinner"
                                                v-if="revokingId === item.id"
                                                aria-hidden="true"
                                            ></span>
                                            <span v-else>{{ t('agentAuthorizations-manage_revoke') }}</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="empty-state" v-else>
                    <div class="col-12 col-md-6 col-lg-4 mx-auto">
                        <div class="box box-elevated padding-large">
                            <div class="icons">
                                <img src="/images/connections/connections.png" height="24" alt="" />
                            </div>
                            <h2 class="title-2">{{ t('agentAuthorizations-manage_empty_title') }}</h2>
                            <p class="text-sm">{{ t('agentAuthorizations-manage_empty') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.page-content {
    min-height: calc(100vh - 20px);
    display: flex;
    flex-direction: column;
}

.empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    width: 100%;

    .box {
        width: 100%;
        max-width: 400px;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: 16px;

        p,
        h2 {
            margin-bottom: 0;
        }
    }
}
</style>

<script>
import keviApi from "../../keviApi";

export default {
    name: "AgentAuthorizations",
    data() {
        return {
            state: "loading",
            authorizations: [],
            revokingId: null,
        };
    },
    mounted() {
        document.getElementsByTagName("title")[0].innerText = this.t("agentAuthorizations-manage_page_title");
        this.loadAuthorizations();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        is(state) {
            return this.state === state;
        },
        setState(state) {
            this.state = state;
        },
        loadAuthorizations() {
            this.setState("loading");
            const options = keviApi.getOptions("agent/authorizations/mine", "GET");
            this.$http(options).then(
                (response) => {
                    if (response.status === 200) {
                        this.authorizations = response.body.authorizations || [];
                    } else {
                        this.authorizations = [];
                    }
                    this.setState("ready");
                },
                () => {
                    this.authorizations = [];
                    this.setState("ready");
                }
            );
        },
        revoke(item) {
            if (!window.confirm(this.t("agentAuthorizations-manage_revoke_confirm"))) {
                return;
            }
            this.revokingId = item.id;
            const options = keviApi.getOptions(
                "agent/authorizations/" + encodeURIComponent(item.id) + "/revoke",
                "POST"
            );
            this.$http(options).then(
                (response) => {
                    this.revokingId = null;
                    if (response.status === 200) {
                        this.$store.dispatch(
                            "notification/success",
                            this.t("agentAuthorizations-manage_revoke_success")
                        );
                        this.loadAuthorizations();
                    } else {
                        this.$store.dispatch(
                            "notification/error",
                            this.t("agentAuthorizations-manage_revoke_error")
                        );
                    }
                },
                () => {
                    this.revokingId = null;
                    this.$store.dispatch(
                        "notification/error",
                        this.t("agentAuthorizations-manage_revoke_error")
                    );
                }
            );
        },
        formatAddress(item) {
            if (item.address_type === "whatsapp") {
                return item.address;
            }
            return item.address_type + "/" + item.address;
        },
        formatDate(value) {
            if (!value) {
                return "-";
            }
            return value;
        },
    },
};
</script>
